import React from 'react';
import Helmet from 'react-helmet';

import { Grid, Cell, Section } from 'formlabs-web-components/Grid';
import { Header } from 'formlabs-web-components/Type';
import { Link, Button } from 'formlabs-web-components/Link';
import { HeroSection } from '../content';

const NotFound = () => (
  <div>
    <Helmet>
      <title>Page Not Found | Formlabs</title>
    </Helmet>
    <HeroSection
      themeColor="#fff"
      backgroundColor="#666"
      headline="Page not found"
      copy=""
      copyPosition="center"
      eyebrowText="CAREERS AT FORMLABS"
      copyBackgroundColor="transparent"
      backgroundImage="https://careers-content-staging-media.formlabs.com/filer_public/ad/57/ad57a3b8-3581-4c79-9cc3-ca6b4e2b74f0/finishing_chaoin_print.jpg"
      imageSize={100}
      copyWidth={18}
    />
    <Section hasContainer={true} marginBefore="4rem">
      <Grid direction="x" gutters="margin" primaryAlignment="align-center">
        <Cell largeSize={10}>
          <div style={{ textAlign: 'center', marginBottom: '8rem' }}>
            <Header level={2} displayAs={3}>
              Sorry, that page cannot be found
            </Header>
            <p>
              You might want to start over at the{' '}
              <Link to="/">careers home page</Link> to find what you are looking
              for, if you're in the wrong area entirely, you can also return
              home to <Link to="https://formlabs.com">Formlabs.com</Link>
            </p>
            <Button url="/" color="dark" arrow="left">
              Back to careers
            </Button>
          </div>
        </Cell>
      </Grid>
    </Section>
  </div>
);

export default NotFound;
